module.exports = __webpack_public_path__ + "static/media/bulldogs.6004bbdd.svg";